import {
  formatDateToLocalISOString,
  getStartDateWhitHoursOfEndDate,
  formatLongDateTime,
} from '@/common/utils/Date';
import { getPlainHour, getDate } from '@/plugins/utils';
import { DURATION_OF_THE_EVENT, TASK_STATUSES } from '@/myTasks/constants';

export function adapterCalendarEvents(allEvents) {
  return allEvents.map((task) => {
    let color = task.subjectColor ? `#${task.subjectColor}` : '#c0c1f9';

    if (task.state == TASK_STATUSES.BACKLOG || task.state == TASK_STATUSES.REJECTED) color += `60`;
    return {
      allDay: task.duration_type == DURATION_OF_THE_EVENT.ALL_DAY,
      backgroundColor: color,
      borderColor: color,
      end: new Date(task.end_date),
      icon: task.attachment ? 'collections' : '',
      id: task.id,
      start: new Date(task.start_date),
      state: task.state,
      title: task.title,
      type: task.type,
    };
  });
}

export function adapterToUpdateEventOrTask(event) {
  const end_date = formatDateToLocalISOString(
    getStartDateWhitHoursOfEndDate(event.start, event.end),
  );
  return {
    start_date: formatDateToLocalISOString(event.start),
    end_date,
    title: event.title,
    type: event.extendedProps.type,
  };
}

export function adapterToUpdateProject(event) {
  const date = formatLongDateTime(event.start);
  return {
    title: event.title,
    due_date: getDate(date),
    due_hour: getPlainHour(date),
  };
}
